import { isNonBlankString } from './onboardingValidation';

export const buildCanvasserOnboardingUrl = (token: string): string => {
  if (!isNonBlankString(token)) {
    throw new Error('Cannot build an onboarding URL without a token.');
  }

  const url = new URL('/onboard-user', window.location.origin);
  url.searchParams.set('token', token);
  return url.toString();
};
